<template>
    <div class="d-flex align-items-center">
        <span
            class="icon"
            :class="icon"
            style="font-size: 19px"
            aria-hidden="true"
        />
        <span
            class="font-size-16 fw-bold text-mw"
            style="padding-left: 7px;"
            v-html="label"
        />
    </div>
</template>

<script>
export default {
    name: "AvailabilityMention",
    props: {
        available: {
            type: Boolean,
            required: true
        },
        label:{
            type: String,
            required: true
        }
    },
    computed: {
        icon() {
            if (this.available) return 'icon-tick-circle';
            else return 'icon-Warning-important';
        }
    }
}
</script>
